// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ci-0";
export var actionModalContentContainer = "_ci-1";
export var createTagButton = "_ci-2";
export var footerContainer = "_ci-7";
export var fullWidthDivider = "_ci-3";
export var hasCreateTagButton = "_ci-4";
export var noCreateTagButton = "_ci-5";
export var tagsContainer = "_ci-6";
export var tagsModalContentContainer = "_ci-8";